// Include Lightbox
import PhotoSwipeLightbox from 'photoswipe/lightbox';
// Caption Plugin für PhotoSwipe
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';

// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Navigation, Pagination, EffectFade, Autoplay} from 'swiper/modules';

/**
 * Ajax form for typo3
 * @param conf
 */
function mpAjaxForm(conf) {
  // Das erste Formular im ausgewählten Element finden
  const form = document.querySelector(this).querySelector('form:first-of-type');

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    // Wert des input[name=ajaxform]-Felds aus dem Formular abrufen
    const ajaxForm = form.querySelector('input[name=ajaxform]').value;

    // Formular per Ajax senden?
    if (ajaxForm > 0 && form.getAttribute('enctype') !== 'multipart/form-data') {
      // Name des input[name=ajaxform]-Felds ändern
      form.querySelector('input[name=ajaxform]').setAttribute('name', 'ajax_form');

      // Formulardaten sammeln
      const form_data = new FormData(form);

      // Fetch-API für Ajax-Anfrage nutzen
      fetch(form.getAttribute('action'), {
        method: form.getAttribute('method'),
        body: form_data,
      }).then((response) => response.text()).then((html) => {
        // HTML-Code in das DOM einfügen
        const cAjaxForm = document.querySelector('#c' + ajaxForm);
        cAjaxForm.outerHTML = html;

        // Eventlistener für das neu eingefügte Formular hinzufügen
        mpAjaxForm.call('#c' + ajaxForm, conf);

        // Bei Bedarf zum neu eingefügten Formular scrollen
        const formTop = cAjaxForm.offsetTop;
        if (window.pageYOffset > formTop) {
          window.scrollTo({top: formTop, behavior: 'smooth'});
        }
      });
    }
  });
}

function adjustGallery() {
  const rows = document.querySelectorAll('.gallery-row');

  rows.forEach((row) => {
    const items = row.querySelectorAll('.gallery-item');
    const images = row.querySelectorAll('img');

    let totalAspectRatio = 0;
    images.forEach((img) => {
      totalAspectRatio += img.naturalWidth / img.naturalHeight;
    });

    // Höhe der Zeile in Relation zur Breite berechnen
    const rowHeight = row.offsetWidth / totalAspectRatio;

    items.forEach((item, index) => {
      const img = images[index];
      const aspectRatio = img.naturalWidth / img.naturalHeight;
      const widthPercentage = (aspectRatio / totalAspectRatio) * 100;
      item.style.width = `${widthPercentage}%`;
    });

    row.style.height = `${rowHeight}px`;
  });

  // show gallery
  const galleries = document.querySelectorAll('.gallery:not(.gallery-init)');
  if (galleries) {
    galleries.forEach((gallery) => {
      gallery.style.opacity = 1;
      gallery.classList.add('gallery-init');
    });
  }
}

// Run the function when images are loaded
window.addEventListener('load', adjustGallery);

// Run on window resize for responsiveness
window.addEventListener('resize', adjustGallery);

// Document Ready
document.addEventListener('DOMContentLoaded', function() {
  // CSS-Klasse wechseln, wenn JS aktiviert ist (für Fallbacks)
  document.querySelector('html').classList.replace('no-js', 'js');

  // Photoswipe config
  const lightbox = new PhotoSwipeLightbox({
    gallery: '.pswp-gallery',
    children: '.pswp-gallery__item',
    pswpModule: () => import('photoswipe'),
  });
  // Photoswipe caption
  // eslint-disable-next-line
  new PhotoSwipeDynamicCaption(lightbox, {
    // Plugins options, for example:
    type: 'below',
    captionContent: (slide) => {
      // Caption aus figcaption ziehen
      return (slide.data.element.nextElementSibling ? slide.data.element.nextElementSibling.textContent : '');
    },
  });
  lightbox.init();

  // Bypass-Menu Button
  document.querySelectorAll('.ce-frame__accessibility-bypass').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const wrap = this.closest('.ce-frame');
      const scrollheight = wrap.offsetTop + wrap.offsetHeight;
      window.scrollTo({top: scrollheight, behavior: 'smooth'});
    });
  });

  // Ajax-Formulare
  document.querySelectorAll('.ce-login').forEach(function(form) {
    mpAjaxForm.call(form, null);
  });

  // Responsive Menu
  const menuButton = document.querySelector('#menu-button');
  const body = document.querySelector('body');

  menuButton.addEventListener('click', function() {
    body.classList.toggle('menu-open');
  });

  document.querySelectorAll('.submenu-open').forEach(function(btn) {
    btn.addEventListener('click', function() {
      this.closest('li').classList.toggle('open');
    });
  });

  // init Swiper:
  const imageSwipers = document.querySelectorAll('.swiper.imageswiper');
  if (imageSwipers) {
    imageSwipers.forEach(function(swiperElement) {
      const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;
      const dynamicBulletsOnMobile = slideCount > 4;
      const dynamicBulletsOnTablet = slideCount > 8;
      const dynamicBulletsOnDesktop = slideCount > 10;

      // eslint-disable-next-line
      const swiper = new Swiper(swiperElement, {
        // configure Swiper to use modules
        modules: [Navigation, Pagination, EffectFade, Autoplay],
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: true,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: dynamicBulletsOnMobile,
          dynamicMainBullets: 1,
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        autoHeight: true,
        loop: true,
        speed: 500,
        breakpoints: {
          // when window width is >= 480px
          480: {
            pagination: {
              dynamicBullets: dynamicBulletsOnTablet,
              dynamicMainBullets: 3,
            },
          },
          // when window width is >= 640px
          1000: {
            pagination: {
              dynamicBullets: dynamicBulletsOnDesktop,
              dynamicMainBullets: 5,
            },
          },
        },
        on: {
          breakpoint: function(swiper) {
            if (swiper.params.pagination.dynamicBullets) {
              swiper.pagination.init();
            } else {
              setTimeout(function() {
                swiper.pagination.el.style.width = 'auto';
                swiper.pagination.el.classList.remove('swiper-pagination-bullets-dynamic');
              });
            }
          },
        },
      });
    });
  }

  // contact form
  const formContainer = document.getElementById('contact-form');
  if(formContainer) {
    formContainer.addEventListener('submit', function(event) {
      event.preventDefault();

      const formData = new FormData(formContainer);

      fetch('/ajax/form/contact.php', {
        method: 'POST',
        body: formData,
      }).then(response => response.text()).then(html => {
        // Den neuen HTML-Inhalt des Formulars einfügen
        formContainer.innerHTML = html;
      }).catch(error => {
        console.error('Fehler:', error);
      });
    });
  }
});